<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="openAddRegist()">新建出入登记</el-button>
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-select v-fixZoom v-model="visitTag" placeholder="请选择" style="width: 130px">
        <el-option v-for="item in visitTagArr" :key="item.value" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button type="success" @click="getSearchData">查询</el-button>
    </div>
    <div style="height: calc(100% - 120px);margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable" height="100%">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="reason"
          label="来访事由"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="people_count"
          label="人数"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="visit_time"
          label="来访时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="level_time"
          label="离开时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          width="100"
          align="center">
          <template slot-scope="scope">
            <div :style="{backgroundColor: scope.row.visit_tag !== 1 ? 'green' : 'red', color: '#ffffff'}">
              {{scope.row.visit_tag !== 1 ? '来访中' : '已离开'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.visit_tag === 1" size="mini" type="primary" plain @click="openEditRegist(scope.row)">修改</el-button>
            <el-button v-if="scope.row.visit_tag !== 1" size="mini" type="success" @click="leaveVisit(scope.row)">确认离开</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" :width="registObj.openType === 0 ? '500px' : '800px'"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ titleShow }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-regist-in-out v-model="addEditShow" :registObj="registObj" @updateTable="updateTable"></add-edit-regist-in-out>
    </el-dialog>
  </div>
</template>

<script>
import {querypersonaccesslog} from '../../api/yanglaoyuan/personaccesslog'
import addEditRegistInOut from './components/addEditRegistInOut'

export default {
  name: 'registInOut',
  components: {addEditRegistInOut},
  data () {
    return {
      sendDate: [],
      visitTag: -1,
      visitTagArr: [{id: -1, name: '全部'}, {id: 0, name: '来访'}, {id: 1, name: '已离开'}],
      pickerOptions: {
        // disabledDate (time) {
        //   return time.getTime() > Date.now()
        // },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,

      tableData: [],
      addEditShow: false,
      titleShow: '',
      registObj: {
        openType: 0, // 0、确认离开 1、新建出入登记 2、修改出入登记
        row: ''
      }
    }
  },
  created () {
    let loginResp = this.$store.state.user.LoginResp
    this.entityId = loginResp.entity_id
    this.espId = loginResp.syspersonid
    this.espName = loginResp.personname
    this.getTimeObj()
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let start = new Date().format('yyyy-MM-dd')
    const end = this.commonType.GetDateStr(30)
    this.sendDate = [start, end.format('yyyy-MM-dd')]
    this.getSearchData()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },

    openAddRegist () {
      this.titleShow = '新建出入登记'
      this.registObj.row = ''
      this.registObj.openType = 1
      this.addEditShow = true
    },
    openEditRegist (row) {
      this.titleShow = '修改出入登记'
      this.registObj.row = row
      this.registObj.openType = 2
      this.addEditShow = true
    },
    leaveVisit (row) {
      this.titleShow = '确认离开'
      this.registObj.row = row
      this.registObj.openType = 0
      this.addEditShow = true
    },

    getSearchData () {
      this.getRegistInOutData()
    },
    updateTable () {
      this.getSearchData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getSearchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getSearchData()
    },

    getRegistInOutData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        e_id: this.entityId,
        visit_tag: this.visitTag,
        from: this.sendDate[0] + ' 00:00:00',
        to: this.sendDate[1] + ' 23:59:59'
      }
      querypersonaccesslog(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.accesslog
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/registInOut.vue